module.exports = __webpack_public_path__ + "static/media/VP.9bf9c065.jpg";